
export const UPDATE_ACTIVE_FOLDER='updateActiveFolder'

export const UPDATE_OPEN_OR_CLOSE_FOLDER='openOrCloseFolder'

export const ADMIN_OPEN_OR_CLOSE_VERTICAL_MENU='adminOpenOrCloseVerticalMenu'

export const ADMIN_OPEN_OR_CLOSE_VERTICAL_MENU_CHILD='adminOpenOrCloseVerticalMenuChild'

export const ADMIN_ACTVE_MENU='adminActiveMenu'

export const USER_GET_INTERFACE='userGetInterface'
